import $http from '@/api/index'
import {
    getToken
} from "../../../util/auth";
const cookieUser = getToken();
//加载自定义流程列表
export function GetCustmerSchemeInfoList() {
	let options = {
		method: 'GET',
		url: 'WfScheme/GetCustmerSchemeInfoList',
		requestType: 1
	}
	let params = {user: JSON.stringify(cookieUser)};
	return $http(options, params)
}

//左侧流程分类
export function GetDataItemTree(itemCode) {
	let options = {
		method: 'GET',
		url: 'DataItem/GetDetailTree',
		requestType: 1
	}
	let params = {itemCode: itemCode};
	return $http(options, params)
}
//判断是否有审批权限
export function GetAuditProcess(processId,userId) {
	let options = {
		method: 'GET',
		url: 'WfMyTask/GetAuditProcess',
		requestType: 1
	}
	let params = {processId: processId,userId:userId};
	return $http(options, params)
}
/**
 * 初始化流程模板->获取开始节点数据
 * @param {*} isNew -是否是新发起的实例
 * @param {*} processId -流程实例主键
 * @param {*} schemeCode -流程模板编号
 * @param {*} currentUser -当前用户
 */
export function Bootstraper(
	isNew,
	processId,
	schemeCode,
	currentUser,
  ) {
	let options = {
	  method: 'GET',
	  url:
		'WfEngine/Bootstraper?isNew=' +
		isNew +
		'&processId=' +
		processId +
		'&schemeCode=' +
		schemeCode +
		'&currentUser=' +
		currentUser,
	  requestType: 1
	}
	let params = {
	}
	return $http(options, params)
  }

/**
 * 流程任务信息
 * @param {*} processId -流程实例主键
 * @param {*} taskId -流程模板编码
 * @param {*} currentUser -当前用户
 */
  export function Taskinfo(
	processId,
	taskId,
	currentUser,
  ) {
	let options = {
	  method: 'GET',
	  url:
		'WfEngine/Taskinfo?&processId=' +
		processId +
		'&taskId=' +
		taskId +
		'&currentUser=' +
		currentUser,
	  requestType: 1
	}
	let params = {
	}
	return $http(options, params)
  }
/**
 * 获取流程实例信息
 * @param {*} processId -流程实例主键
 * @param {*} taskId -流程模板编码
 * @param {*} currentUser -当前用户
 */
  export function Processinfo(
	processId,
	taskId,
	currentUser,
  ) {
	let options = {
	  method: 'GET',
	  url:
		'WfEngine/Processinfo?&processId=' +
		processId +
		'&taskId=' +
		taskId +
		'&currentUser=' +
		currentUser,
	  requestType: 1
	}
	let params = {
	}
	return $http(options, params)
  }
/**
 * 创建流程实例
 * @param {*} taskId -流程实例ID
 * @param {*} verifyType -流程模板编码
 * @param {*} description -流程实例名称
 * @param {*} auditorId -加签人员Id
 * @param {*} auditorName -备注说明
 * @param {*} currentUser -当前用户
 * @param {*} auditers -下一个环节审批人
 * @param {*} formData -表单数据
 */
  export function Audit(
	taskId,
	verifyType,
	description,
	auditorId,
	auditorName,
	currentUser,
	auditers,
	formData
  ) {
	let options = {
	  method: 'POST',
	  url:
		'WfEngine/Audit?&taskId=' +
		taskId +
		'&verifyType=' +
		verifyType +
		'&description=' +
		description+
		'&auditorId=' +
		auditorId+
		'&auditorName=' +
		auditorName+
		'&auditers=' +
		auditers+
		'&formData=' +
		formData+
		'&currentUser=' +
		currentUser,
	  requestType: 1
	}
	let params = {
	}
	return $http(options, params)
	}
	

export function Auditer(
	isNew,
	processId,
	schemeCode,
	taskId,
	formData,
	taskInfo,
	currentUser,
  ) {
	let options = {
	  method: 'GET',
	  url:
		'WfEngine/Auditer?&isNew=' +
		isNew +
		'&processId=' +
		processId +
		'&schemeCode=' +
		schemeCode+
		'&taskId=' +
		taskId+
		'&formData=' +
		formData+
		'&taskInfo=' +
		taskInfo+
		'&currentUser=' +
		currentUser,
	  requestType: 1
	}
	let params = {
	}
	return $http(options, params)
	}